module.exports = __webpack_public_path__ + "static/media/man-smiling-with-bread.6e2bf669.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2019-10-18/man-smiling-with-bread.jpg
// module id = 820
// module chunks = 0